var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRotate90DegreesCcw = function SvgRotate90DegreesCcw(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.394 21.952a8.4 8.4 0 0 1-2.306-.322 8.3 8.3 0 0 1-2.128-.944l1.084-1.084a6.8 6.8 0 0 0 1.625.637 7 7 0 0 0 1.725.213q2.925 0 4.963-2.038 2.037-2.037 2.037-4.962t-2.037-4.963-4.963-2.037h-.727l1.781 1.78-1.054 1.123-3.653-3.653 3.653-3.654 1.054 1.123-1.78 1.78h.726q3.542 0 6.021 2.48 2.48 2.478 2.48 6.02 0 1.77-.67 3.316a8.6 8.6 0 0 1-1.82 2.696 8.6 8.6 0 0 1-2.695 1.82 8.3 8.3 0 0 1-3.316.669m-6-3.212-5.288-5.288 5.288-5.289 5.289 5.289zm0-2.138 3.15-3.15-3.15-3.15-3.15 3.15z"
  })));
};
export default SvgRotate90DegreesCcw;